import angular from 'angular';
import EditPickupPointComponent from './edit.component';

const EditPickupPointModule = angular.module('tinaba.components.services.orderAndPay.pickupPoint.edit', [])

.component('editPickupPoint', EditPickupPointComponent);

export default EditPickupPointModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPay/pickupPoint/edit/edit.js
 **/